import { useCallback } from 'react';
import useLocalStorageState from 'use-local-storage-state';

import { type UserInfo } from '@/types';

export const useUserLocalStorageState = () => {
  const [user, setUser] = useLocalStorageState<UserInfo | null>('quiz_user', {
    defaultValue: null,
  });

  // useCallback 으로 안정적인 함수 정체성을 보장한다.
  // 이 함수들은 UserContext 의 effect deps 로 쓰이는데, 매 렌더 새로 만들면
  // effect 가 불필요하게 재실행되어 인증 상태가 반복 초기화되는 문제가 있었다.
  const setUserStable = useCallback(
    (newUser: UserInfo | null) => {
      setUser(newUser);
    },
    [setUser],
  );

  const clearUser = useCallback(() => {
    setUser(null);
  }, [setUser]);

  return {
    user,
    setUser: setUserStable,
    clearUser,
  };
};
